import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

interface ProgressBarProps {
  /** The current position in the progress */
  current: number;

  /** Label to display. Use the placeholder `#c` to display current position and `#t` to display total */
  label: string;

  /** Total number of steps */
  total: number;
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
});

function ProgressBar({ current, label, total }: ProgressBarProps) {
  const id = Date.now().toString(); // TODO: Replace with useId hook after upgrading to React 18

  const classes = useStyles();

  const progress = Math.round((current / total) * 100);

  const formattedLabel = label
    .replace('#c', current.toString())
    .replace('#t', total.toString());

  return (
    <div className={classes.root}>
      <Typography component="label" htmlFor={id} variant="subtitle2">
        {formattedLabel}
      </Typography>

      <LinearProgress
        id={id}
        variant="determinate"
        value={progress}
        data-testid="atr-progress-bar"
      />
    </div>
  );
}

export default ProgressBar;
